Vue.component("priority-navigation-item", {
    name: 'priority-navigation-item',
    props: [
        'item',
    ],
});

